export const StorageService = {
    setItem(key, value) {
        return localStorage.setItem(key, value);
    },
    getItem(key) {
        return localStorage.getItem(key);
    },
    removeItem(key) {
        localStorage.removeItem(key);
    }
}

export default StorageService;


// WEBPACK FOOTER //
// ./src/service/StorageService.js